import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserRole } from '../../core/enums/users/role';
import { UserStateService } from '../user/shared/services/user-state/user-state.service';
import { EwaStaffDashboardComponent } from './components/ewa-staff-dashboard/ewa-staff-dashboard.component';
import { CustomerDashboardComponent } from './components/customer-dashboard/customer-dashboard.component';
import { WelcomeBannerComponent } from './components/welcome-banner/welcome-banner.component';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        EwaStaffDashboardComponent,
        CustomerDashboardComponent,
        WelcomeBannerComponent,
    ],
})
export class DashboardComponent {
    constructor(private readonly userStateService: UserStateService) {}

    isCustomerView(): boolean {
        return this.userStateService.getRole() === UserRole.Customer;
    }
}
